module.exports = __webpack_public_path__ + "img/a011_1.fce67191.jpeg";